import { useQuery } from '@tanstack/react-query'

import { useApi } from 'hooks'

const useGetAd = () => {
  const { apiFetch } = useApi()

  const url = '/advertisements'

  const getAd = () => {
    return apiFetch({ url })
      .then(res => res.data)
  }

  const options = {
    placeholderData: null,
    refetchOnWindowFocus: false,
  }

  return useQuery(['ad'], getAd, options)
}

export default useGetAd
